import store from './../store/index'
import { rawFetch } from './rawFetch'

// Экран обслуживания показываем только по ответу нашего бэкенда. Подменяется
// глобальный window.fetch, поэтому через перехват идут и запросы чужих скриптов
// — Jivo, GTM, Метрики. Без проверки хоста их 503 рисовал бы на сайте нашу
// заглушку, хотя сайт полностью работоспособен.
//
// Все ручки живут на поддоменах backend-pier.com (transfer, users, payments,
// prices, logpass). Сравнение по точной границе домена, а не по вхождению
// строки: иначе под правило попал бы любой хост, оканчивающийся на эти буквы.
const API_DOMAIN = 'backend-pier.com'

const isOurApi = input => {
  // fetch принимает строку, URL или Request — адрес достаём из любого.
  const url = typeof input === 'string' ? input : input && (input.url || String(input))

  if (!url) return false

  try {
    const { hostname } = new URL(url, window.location.origin)

    return hostname === API_DOMAIN || hostname.endsWith(`.${API_DOMAIN}`)
  } catch (err) {
    return false
  }
}

/**
 * HTTP Interceptor для обработки глобальных ошибок
 * Перехватывает все fetch запросы и обрабатывает 503 ошибки
 */
export function setupHttpInterceptor() {
  window.fetch = async function (...args) {
    const response = await rawFetch(...args)

    // 503 показываем флагом в store, а не переходом на роут /503.
    //
    // Переход менял адрес только на клиенте, а документ оставался тем, который
    // загрузил робот, — например главной. На неё и прилетал noindex от роута
    // /503, а вместе с ним пропадал canonical: App.vue гасит его для любого
    // noindex-роута. Одного 503 от любой ручки хватало, чтобы главная выпала из
    // индекса, — так и случилось после релиза (RBXGD-1119).
    //
    // Роут /503 остаётся для прямых заходов: там noindex приходит заголовком
    // X-Robots-Tag от nginx и относится к настоящему адресу /503.
    if (response.status === 503 && isOurApi(args[0])) {
      store.commit('setServiceUnavailable', true)
    }

    return response
  }
}

export default setupHttpInterceptor
